import type { MerchantRow } from '../api/types';

export const MERCHANT_DEFAULTS = {
  rolling_reserve_percent: 5,
  daily_limit_aed: 50000,
  corporate_structure: 'Private Limited Company (LLC)',
} as const;

export function merchantRollingReserve(m: MerchantRow): number {
  return m.rolling_reserve_percent ?? MERCHANT_DEFAULTS.rolling_reserve_percent;
}

export function merchantDailyLimit(m: MerchantRow): number {
  return m.daily_limit_aed ?? MERCHANT_DEFAULTS.daily_limit_aed;
}

export function merchantCorporateStructure(m: MerchantRow): string {
  return m.corporate_structure?.trim() || MERCHANT_DEFAULTS.corporate_structure;
}
